module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"caption":"Tips: Update your login password.","action":"LET\u0027S PROCEED"},"it":{"caption":"Consigli: Aggiorna la password di login.","action":"PROCEDIAMO"}}')
  delete Component.options._Ctor
}
